
import * as THREE from "../../libs/three.js/build/three.module.js";
import { BoxVolume } from "./Volume.js";
import { Utils } from "../utils.js";
import { PointSizeType } from "../defines.js";
import { EventDispatcher } from "../EventDispatcher.js";


export class ScreenBoxSelectTool extends EventDispatcher {

	constructor(viewer) {
		super();

		this.viewer = viewer;
		this.scene = new THREE.Scene();

		viewer.addEventListener("update", this.update.bind(this));
		viewer.addEventListener("render.pass.perspective_overlay", this.render.bind(this));
		viewer.addEventListener("scene_changed", this.onSceneChange.bind(this));
	}

	onSceneChange(scene) {
		console.log("scene changed");
	}

	startInsertion() {
		let domElement = this.viewer.renderer.domElement;

		let volume = new BoxVolume();
		volume.position.set(12345, 12345, 12345);
		volume.showVolumeLabel = false;
		volume.visible = false;
		volume.update();
		this.viewer.scene.addVolume(volume);

		this.importance = 10;

		let selectionBox = $(`<div style="position: absolute; border: 2px solid white; pointer-events: none; border-style:dashed"></div>`);
		$(domElement.parentElement).append(selectionBox);
		selectionBox.css("right", "10px");
		selectionBox.css("bottom", "10px");

		let drag = e => {

			// 拖动期间 3D 包围盒保持隐藏 —— 白色虚线 HTML rect 已经提供视觉
			// 反馈。原本的 volume.visible=true + volume.position=camera.position
			// + volume.rotation=camera.rotation + scale.z=1000*100 在透视相机下
			// 会画出一个"黄色边框+绿色填充"的 3D 盒子，位置和尺寸都与 drag rect
			// 无关（local-Z 沿相机 forward，投影固定在屏幕中心；scale.x/y 也是
			// undefined 相减出的 NaN 或 ortho 全宽）。真正正确的 3D 盒子在 drop
			// 里根据 pick 到的景深 + 4 角射线重建，drop 时才 visible=true。
			volume.visible = false;

			let mStart = e.drag.start;
			let mEnd = e.drag.end;

			let box2D = new THREE.Box2();
			box2D.expandByPoint(mStart);
			box2D.expandByPoint(mEnd);

			selectionBox.css("left", `${box2D.min.x}px`);
			selectionBox.css("top", `${box2D.min.y}px`);
			selectionBox.css("width", `${box2D.max.x - box2D.min.x}px`);
			selectionBox.css("height", `${box2D.max.y - box2D.min.y}px`);

			e.consume();
		};

		let drop = e => {
			this.importance = 0;

			$(selectionBox).remove();

			this.viewer.inputHandler.deselectAll();
			this.viewer.inputHandler.toggleSelection(volume);

			let camera = e.viewer.scene.getActiveCamera();
			let size = e.viewer.renderer.getSize(new THREE.Vector2());
			let screenCentroid = new THREE.Vector2().addVectors(e.drag.end, e.drag.start).multiplyScalar(0.5);
			let ray = Utils.mouseToRay(screenCentroid, camera, size.width, size.height);

			let line = new THREE.Line3(ray.origin, new THREE.Vector3().addVectors(ray.origin, ray.direction));

			this.removeEventListener("drag", drag);
			this.removeEventListener("drop", drop);

			let allPointsNear = [];
			let allPointsFar = [];

			// TODO support more than one point cloud
			for (let pointcloud of this.viewer.scene.pointclouds) {

				if (!pointcloud.visible) {
					continue;
				}

				let volCam = camera.clone();
				volCam.left = -volume.scale.x / 2;
				volCam.right = +volume.scale.x / 2;
				volCam.top = +volume.scale.y / 2;
				volCam.bottom = -volume.scale.y / 2;
				volCam.near = -volume.scale.z / 2;
				volCam.far = +volume.scale.z / 2;
				volCam.rotation.copy(volume.rotation);
				volCam.position.copy(volume.position);

				volCam.updateMatrix();
				volCam.updateMatrixWorld();
				volCam.updateProjectionMatrix();
				volCam.matrixWorldInverse.copy(volCam.matrixWorld).invert();

				let ray = new THREE.Ray(volCam.getWorldPosition(new THREE.Vector3()), volCam.getWorldDirection(new THREE.Vector3()));
				let rayInverse = new THREE.Ray(
					ray.origin.clone().add(ray.direction.clone().multiplyScalar(volume.scale.z)),
					ray.direction.clone().multiplyScalar(-1));

				let pickerSettings = {
					width: 8,
					height: 8,
					pickWindowSize: 8,
					all: true,
					pickClipped: true,
					pointSizeType: PointSizeType.FIXED,
					pointSize: 1
				};
				let pointsNear = pointcloud.pick(this.viewer, volCam, ray, pickerSettings);

				volCam.rotateX(Math.PI);
				volCam.updateMatrix();
				volCam.updateMatrixWorld();
				volCam.updateProjectionMatrix();
				volCam.matrixWorldInverse.copy(volCam.matrixWorld).invert();
				let pointsFar = pointcloud.pick(this.viewer, volCam, rayInverse, pickerSettings);

				allPointsNear.push(...pointsNear);
				allPointsFar.push(...pointsFar);
			}

			// GS 兼底：3DGS 场景没有 pointcloud.pick，drop 时 volume.scale.z
			// 会一直是 drag 时给的 1000*100 巨深（volume 中心在相机位置，视觉上
			// 与拖动的白色虚线也对不上）。用 THREE.Raycaster + SplatMesh.raycast
			// 采样 rect 内的一个自适应密度网格，把命中的 splat 全部塞进
			// allPointsNear/Far —— 后面的 closestOnLine/farthestOnLine 投影
			// 一体化处理，与 PC 分支收敛到同一段代码。
			//
			// 采样密度自适应：曾经用 5 条射线（中心+4 角）会漏掉
			// 明明在框内、但没压在这 5 像素上的近景 splat（例如前景细管），
			// 导致 volume 近面被推到背景一起，看上去"框里靠相机侧的高斯没被选中"。
			// 现在按 rect 尺寸每 ~10 像素铺一条射线，行列各上限 32，兼顾
			// 覆盖率与开销（drop 是一次性事件，每条 mesh.raycast 内部是 WASM
			// 全 splat 扫描，32×32 = 1024 次仍在几百 ms 以内）。
			if (allPointsNear.length === 0 || allPointsFar.length === 0) {
				const splats = (this.viewer.scene.gaussianSplats || []).filter(
					m => m && m.visible !== false && m.initialized !== false && m.raycastable !== false
				);
				if (splats.length > 0) {
					const domEl = this.viewer.renderer.domElement;
					const w = domEl.clientWidth;
					const h = domEl.clientHeight;

					const rectMinX = Math.min(e.drag.start.x, e.drag.end.x);
					const rectMinY = Math.min(e.drag.start.y, e.drag.end.y);
					const rectMaxX = Math.max(e.drag.start.x, e.drag.end.x);
					const rectMaxY = Math.max(e.drag.start.y, e.drag.end.y);
					const rectW = Math.max(1, rectMaxX - rectMinX);
					const rectH = Math.max(1, rectMaxY - rectMinY);

					const STEP_PX = 10;
					const MIN_N = 5;
					const MAX_N = 32;
					const cols = Math.max(MIN_N, Math.min(MAX_N, Math.floor(rectW / STEP_PX) + 1));
					const rows = Math.max(MIN_N, Math.min(MAX_N, Math.floor(rectH / STEP_PX) + 1));

					const raycaster = new THREE.Raycaster();
					raycaster.near = camera.near;
					raycaster.far  = camera.far;

					const gsHits = [];
					for (let j = 0; j < rows; ++j) {
						const ty = rows === 1 ? 0.5 : j / (rows - 1);
						const py = rectMinY + ty * rectH;
						for (let i = 0; i < cols; ++i) {
							const tx = cols === 1 ? 0.5 : i / (cols - 1);
							const px = rectMinX + tx * rectW;
							raycaster.setFromCamera(
								{ x: (px / w) * 2 - 1, y: -(py / h) * 2 + 1 },
								camera
							);
							for (const mesh of splats) {
								mesh.raycast(raycaster, gsHits);
							}
						}
					}

					if (gsHits.length > 0) {
						// 每个 splat 命中点既作为 near 候选又作为 far 候选；
						// 下面的 viewLine.closestPointToPoint + 排序会自动选出
						// 沿视线方向最近/最远的两个点。
						for (const hit of gsHits) {
							allPointsNear.push({ position: hit.point.clone() });
							allPointsFar.push({  position: hit.point.clone() });
						}
					}
				}
			}

			if (allPointsNear.length > 0 && allPointsFar.length > 0) {
				let viewLine = new THREE.Line3(ray.origin, new THREE.Vector3().addVectors(ray.origin, ray.direction));

				let closestOnLine = allPointsNear.map(p => viewLine.closestPointToPoint(p.position, false, new THREE.Vector3()));
				let closest = closestOnLine.sort((a, b) => ray.origin.distanceTo(a) - ray.origin.distanceTo(b))[0];

				let farthestOnLine = allPointsFar.map(p => viewLine.closestPointToPoint(p.position, false, new THREE.Vector3()));
				let farthest = farthestOnLine.sort((a, b) => ray.origin.distanceTo(b) - ray.origin.distanceTo(a))[0];

				let distance = closest.distanceTo(farthest);
				// 用 rect 四角像素在 midDepth (沿 centroid ray 的 near/far 中点)
				// 处的世界坐标，重建 box 的三条 local 轴。原代码里 volume.rotation
				// 是从 drag callback 里 copy 的 camera.rotation —— box 的 local-Z
				// 因此沿相机 forward，穿过屏幕中心；把 scale.z 拉到 near-far 距离
				// (GS 场景下 1000*100 直接是 100000) 后，box 近面沿相机 forward
				// 被顶得远远的，投影自然落回屏幕中心而不是 drag 矩形中心。
				// 现在改成：local-Z 沿 centroid ray 方向，local-X/Y 由 rect 角在
				// midDepth 展开得到 → box 在 3D 中就是 drag rect 从相机射出去的
				// 那截"稍微贴合景深"的截锥近似盒。
				const size2 = this.viewer.renderer.getSize(new THREE.Vector2());
				const rectMinX = Math.min(e.drag.start.x, e.drag.end.x);
				const rectMinY = Math.min(e.drag.start.y, e.drag.end.y);
				const rectMaxX = Math.max(e.drag.start.x, e.drag.end.x);
				const rectMaxY = Math.max(e.drag.start.y, e.drag.end.y);

				const cornerRay = (px, py) => {
					const rc = new THREE.Raycaster();
					rc.setFromCamera(
						{ x: (px / size2.width) * 2 - 1, y: -(py / size2.height) * 2 + 1 },
						camera
					);
					return rc.ray;
				};

				const rayTL = cornerRay(rectMinX, rectMinY);
				const rayTR = cornerRay(rectMaxX, rectMinY);
				const rayBL = cornerRay(rectMinX, rectMaxY);
				const rayBR = cornerRay(rectMaxX, rectMaxY);

				const viewDir = ray.direction.clone().normalize();
				const midAlongView = viewDir.dot(
					new THREE.Vector3().addVectors(closest, farthest).multiplyScalar(0.5)
						.sub(ray.origin)
				);

				// 把 rect 每个角上的射线延伸到"沿 centroid ray 方向 midAlongView 深度"
				// 的那个截面，得到 4 个世界坐标角点。对透视/正交相机都成立
				// (raycaster.setFromCamera 已处理 ortho 情形)。
				const extendToDepth = (r) => {
					const den = r.direction.dot(viewDir);
					if (Math.abs(den) < 1e-8) return null;
					const num = midAlongView - viewDir.dot(new THREE.Vector3().subVectors(r.origin, ray.origin));
					return r.origin.clone().addScaledVector(r.direction, num / den);
				};

				const wTL = extendToDepth(rayTL);
				const wTR = extendToDepth(rayTR);
				const wBL = extendToDepth(rayBL);
				const wBR = extendToDepth(rayBR);

				if (wTL && wTR && wBL && wBR) {
					const faceCenter = new THREE.Vector3()
						.add(wTL).add(wTR).add(wBL).add(wBR).multiplyScalar(0.25);

					const boxX = new THREE.Vector3().subVectors(wTR, wTL).normalize();
					const boxY = new THREE.Vector3().subVectors(wBL, wTL).normalize();
					const boxZ = new THREE.Vector3().crossVectors(boxX, boxY).normalize();
					// 重建正交 Y (X 和 Z 优先)
					const boxYo = new THREE.Vector3().crossVectors(boxZ, boxX).normalize();

					const width  = wTR.distanceTo(wTL);
					const height = wBL.distanceTo(wTL);

				const m = new THREE.Matrix4().makeBasis(boxX, boxYo, boxZ);
					volume.quaternion.setFromRotationMatrix(m);
					volume.position.copy(faceCenter);
					volume.scale.set(width, height, distance * 1.1);
					volume.visible = true;
				} else {
					// 兼底：只调 z 和位置，与老逻辑一致
					const centroid = new THREE.Vector3().addVectors(closest, farthest).multiplyScalar(0.5);
					volume.scale.z = distance * 1.1;
					volume.position.copy(centroid);
					volume.visible = true;
				}
			}

				volume.clip = true;
		};

		this.addEventListener("drag", drag);
		this.addEventListener("drop", drop);

		this.viewer.inputHandler.addInputListener(this);

		return volume;
	}

	update(e) {
		//console.log(e.delta)
	}

	render() {
		this.viewer.renderer.render(this.scene, this.viewer.scene.getActiveCamera());
	}

}